/**
 * Full-page navigation helper.
 *
 * A thin, single-purpose wrapper around a browser hard-redirect. It exists so
 * callers that need to leave the SPA entirely (e.g. handing off to Stripe's
 * hosted Checkout / Billing Portal) have one testable seam: `window.location`
 * is non-configurable under jsdom, so tests mock this module rather than trying
 * to stub `window.location.assign` directly.
 */

/**
 * Redirect the browser to an absolute URL, leaving the SPA. Uses
 * `window.location.assign` so the departure is recorded in browser history.
 */
export function redirectTo(url: string): void {
  window.location.assign(url);
}
